package com.milta.core.localization.translations.en

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 address not located",
    warningTitlePlural = "%d addresses not located",
    warningMessage = "These deliveries could not be placed on the map. Correct their address, or continue: they will be put at the end of the route.",
    fixAction = "Correct",
    continueWithoutAction = "Continue without them",
    unplacedStopsSingular = "1 stop not placed, at the end of the route",
    unplacedStopsPlural = "%d stops not placed, at the end of the route",
    fixAddressAction = "Correct the address",
    unlocatedBadge = "Not located",
)
